import axios from './axiosInstances/axiosInstance';

export const removeAppliedRewardFromBasket = (basketId, reference) => {
  return axios.delete(`baskets/${basketId}/loyaltyrewards/${reference}`);
};
